var socketUri = process.env.NODE_ENV === "production" ? window.location.origin : 'localhost:8080';
export default socketUri;
//# sourceMappingURL=socketUri.js.map